import React from "react";
import { useDispatch } from "react-redux";
import NumberFormat from "react-number-format";
import { getProductDetailAction } from "../../../../../redux/action/serviceAction";

function ServiceListCard(props) {
  const dispatch = useDispatch();
  const { item, setModalShow } = props;
  const getProductDetail = (id) => {
    dispatch(getProductDetailAction(id));
    setModalShow(true);
  };

  return (
    <div className="service-cards" key={item._id}>
      <div className="image-cards">
        <img
          src={item?.image || process.env.REACT_APP_IMAGE_ARTICLE}
          alt="empty"
        />
      </div>
      <div className="cards-content">
        <div className="content-title">{item?.name}</div>
        <div className="cards-content__item-info__price">
          {item.priceDiscount !== "" && parseInt(item?.priceDiscount) !== 0 ? (
            <>
              <h3 className="cards-content__item-info__price-normal-strike">
                <NumberFormat
                  prefix={"Rp "}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  displayType="text"
                  value={item?.price}
                />
              </h3>
              <h3 className="cards-content__item-info__price-discount">
                <NumberFormat
                  prefix={"Rp "}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  displayType="text"
                  value={item?.priceDiscount}
                />
              </h3>
            </>
          ) : (
            <h3 className="cards-content__item-info__price-normal">
              <NumberFormat
                prefix={"Rp "}
                thousandSeparator={"."}
                decimalSeparator={","}
                displayType="text"
                value={item?.price}
              />
            </h3>
          )}
        </div>
        <div className="desc-card">
          {item?.description?.length > 80
            ? `${item?.description.slice(0, 80)}...`
            : item?.description}
        </div>
        <div className="service-card-footer w-100">
          <button
            className="p-button p-button-primary"
            onClick={() => getProductDetail(item._id)}
          >
            PESAN
          </button>
        </div>
      </div>
    </div>
  );
}

export default ServiceListCard;
